export function isPerActiveSitePlan(planId: string) {
  return planId !== "free";
}

export const CORE_PLAN_DISPLAY = {
  badgeLabel: "Core",
  heroPriceDisplay: "£89",
  priceDisplay: "£89.00",
  planName: "Core",
} as const;

export const BASE_PLAN_DISPLAY = {
  badgeLabel: "Base",
  heroPriceDisplay: "£19",
  priceDisplay: "£19.00",
  planName: "Base",
} as const;

export function describeBillingInterval(interval: string) {
  if (interval === "monthly") {
    return "month";
  }

  return interval;
}

export function describeBillingLabel(planId: string, interval: string) {
  if (isPerActiveSitePlan(planId)) {
    return "active site / month";
  }

  return describeBillingInterval(interval);
}

export function describePlanCapacity(planId: string, limit: number) {
  if (isPerActiveSitePlan(planId)) {
    return "per-active-site pricing and unlimited workers";
  }

  if (!Number.isFinite(limit)) {
    return "unlimited active sites and unlimited workers";
  }

  if (limit === 1) {
    return "1 active site and unlimited workers";
  }

  return `up to ${limit} active sites and unlimited workers`;
}

export function describeSiteUsageLabel(planId: string) {
  return isPerActiveSitePlan(planId) ? "Billed sites" : "Sites included";
}
